<template>
  <div class="postContainer">
    <div class="header">
      <div class="title">岗位分析</div>
      <div class="headerImg">
        <div class="imgContent">
          <SvgIcon icon-class="iconicon"></SvgIcon>
        </div>
      </div>
    </div>
    <div class="postInfo">
      <div class="tabBar">
        <div class="tabBarItem active" @click="change">
          JAVA工程师
          <div></div>
        </div>
        <div class="tabBarItem" @click="change">
          测试工程师
          <div></div>
        </div>
        <div class="tabBarItem" @click="change">
          前端工程师
          <div></div>
        </div>
        <div class="tabBarItem" @click="change">
          前端工程师
          <div></div>
        </div>
      </div>
    </div>
    <div class="chartsContent">
      <div class="contentItem">
        <div class="title" @click="showOrHide(500, 0)">
          <div class="img"></div>
          <span>岗位技能分析</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts1></charts1>
        </div>
      </div>
      <div class="contentItem">
        <div class="title" @click="showOrHide(400, 1)">
          <div class="img"></div>
          <span>岗位薪酬分析</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts2></charts2>
        </div>
      </div>
      <div class="contentItem">
        <div class="title" @click="showOrHide(400, 2)">
          <div class="img"></div>
          <span>岗位经验要求</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts3></charts3>
        </div>
      </div>
      <div class="contentItem">
        <div class="title" @click="showOrHide(400, 3)">
          <div class="img"></div>
          <span>企业性质</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts4></charts4>
        </div>
      </div>
      <div class="contentItem">
        <div class="title" @click="showOrHide(400, 4)">
          <div class="img"></div>
          <span>企业要求关键词</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts5></charts5>
        </div>
      </div>
      <div class="contentItem">
        <div class="title" @click="showOrHide(400, 5)">
          <div class="img"></div>
          <span>工作内容分析</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="content" style="height: 0;padding-bottom: 0;">
          <charts6></charts6>
        </div>
      </div>
    </div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
import backTo from "@/components/back";
import charts1 from "./charts/charts1";
import charts2 from "./charts/charts2";
import charts3 from "./charts/charts3";
import charts4 from "./charts/charts4";
import charts5 from "./charts/charts5";
import charts6 from "./charts/charts6";
import { Icon } from "vant";
export default {
  components: {
    backTo,
    [Icon.name]: Icon,
    charts1,
    charts2,
    charts3,
    charts4,
    charts5,
    charts6
  },
  data() {
    return {};
  },
  methods: {
    change(e) {
      if (e.target.children.length === 0) {
        return false;
      }
      document.querySelectorAll(".tabBarItem").forEach(item => {
        item.className = "tabBarItem";
      });
      e.target.className = "tabBarItem active";
      document.querySelectorAll(".chartsContent>div>.content").forEach(item => {
        item.style.height = 0 + "px";
      });
      document.querySelectorAll(".chartsContent>div>.content").forEach(item => {
        item.style.paddingBottom = "0px";
      });
      document.querySelectorAll(".chartsContent>div>.title>i").forEach(item => {
        item.style.transform = "rotate(0)";
      });
    },
    showOrHide(height, index) {
      index = index + 1;
      if (
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.content"
        ).style.height === "0px"
      ) {
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.content"
        ).style.height =
          height /
            (750 / document.querySelector(".postContainer").clientWidth) +
          "px";
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.content"
        ).style.paddingBottom = "40px";
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.title>i"
        ).style.transform = "rotate(-180deg)";
      } else {
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.content"
        ).style.height = 0 + "px";
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.content"
        ).style.paddingBottom = "0px";
        document.querySelector(
          ".chartsContent>div:nth-of-type(" + index + ")>.title>i"
        ).style.transform = "rotate(0)";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.postContainer {
  background-color: #fff;
  .header {
    height: 280px;
    background-image: url("../../assets/bg-biyeyaoqiu.png");
    background-size: 100% 100%;
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      letter-spacing: $letter-spacing;
    }
    .headerImg {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      bottom: 40px;
      margin-left: -60px;
      background-color: #fff;
      padding: 10px;
      .imgContent {
        width: 100px;
        height: 100px;
        background-color: #e5f7f3;
        border-radius: 50%;
        text-align: center;
        line-height: 123px;
        svg {
          width: 58px;
          height: 54px;
        }
      }
    }
  }
  .postInfo {
    padding: 0 24px 20px;
    margin-bottom: 30px;
    .tabBar {
      margin-top: 30px;
      font-size: 26px;
      font-family: PingFangSC;
      font-weight: 600;
      letter-spacing: $letter-spacing;
      display: flex;
      overflow-x: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
      }
      .tabBarItem {
        min-width: 33%;
        flex: 1;
        text-align: center;
        position: relative;
        height: 55px;
        color: #969696;
        &.active {
          color: $color-primary;
          div {
            width: 50px;
            height: 8px;
            background: $color-primary;
            border-radius: 4px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  .chartsContent {
    padding: 0 24px 30px;
    .contentItem {
      overflow: hidden;
      padding: 40px 40px 0 30px;
      box-shadow: $box-shadow;
      margin-bottom: 30px;
      .title {
        margin-bottom: 40px;
        .img {
          width: 35px;
          display: inline-block;
          height: 20px;
          background-image: url("../../assets/dian-biaoti.png");
          background-size: 100% 100%;
          margin-right: 20px;
        }
        span {
          font-size: 30px;
          font-weight: 500;
          color: #323232;
          letter-spacing: $letter-spacing;
        }
        i {
          transition: all 0.5s;
          width: 30px;
          float: right;
          margin-top: 5px;
          color: #ddd;
        }
      }
      .content {
        transition: all 0.5s;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        .item {
          float: left;
          width: 30%;
          height: 70px;
          background: #f4f4f4;
          border-radius: 10px;
          line-height: 70px;
          text-align: center;
          font-size: 24px;
          color: #969696;
          letter-spacing: $letter-spacing;
          margin-bottom: 20px;
          margin: 0 1.6% 20px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
